import React from 'react';
import { useTranslation } from 'react-i18next';
import { AlertTriangle } from 'lucide-react';
import Button from '../../../../../components/ui/Button';
import { Dialog, DialogContent, DialogHeader, DialogBody, DialogFooter, DialogTitle } from '../../../../../components/ui/Dialog';

export const KsaFileWarningDialog: React.FC<{ open: boolean; onOpenChange: (open: boolean) => void }> = ({ open, onOpenChange }) => {
  const { t } = useTranslation();
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <AlertTriangle className="w-5 h-5 text-amber-500" />
            {t('payroll.complianceCenter.ksaWps.fileWarningTitle', 'File Generated Successfully')}
          </DialogTitle>
        </DialogHeader>
        <DialogBody>
          <p className="text-sm text-muted-foreground">
            {t('payroll.complianceCenter.ksaWps.fileWarningBody',
              'If you open this file in Excel, dates may be reformatted (e.g. 2026-06-01 becomes 6/1/2026) and numeric fields may change appearance. If you save after opening, these changes could make the file incompatible with Mudad.')}
          </p>
          <p className="text-sm font-medium mt-3">
            {t('payroll.complianceCenter.ksaWps.fileWarningAdvice',
              'If the file will be opened and edited, double check the changes before uploading to Mudad.')}
          </p>
        </DialogBody>
        <DialogFooter className="justify-center">
          <Button onClick={() => onOpenChange(false)}>
            {t('common.ok', 'OK')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
